import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { createParser } from "./create-parser";
/**
 * Combine multiple style prop parsers
 * into a single parser.
 *
 * @param parsers list of parsers
 */

export function combineParsers() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  for (var _i = 0, _parsers = parsers; _i < _parsers.length; _i++) {
    var _parser = _parsers[_i];
    if (!_parser || !_parser.config) continue;
    config = _extends({}, config, _parser.config);
  }

  var parser = createParser(config);
  parser.config = config;
  parser.propNames = Object.keys(config);
  return parser;
}